import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '.';
import type { DealerLocationData, StockCarTypes, VehicleByAudiCode } from '../types';

interface DealerAndVehicleTypes {
  dealer: DealerLocationData | undefined;
  vehicle: StockCarTypes | undefined;
  vehicleByCarline: VehicleByAudiCode | undefined;
  vehicleByAudiCode: VehicleByAudiCode | undefined;
}

const initialState: DealerAndVehicleTypes = {
  dealer: undefined,
  vehicle: undefined,
  vehicleByCarline: undefined,
  vehicleByAudiCode: undefined,
};

const dealerAndVehicleSlice = createSlice({
  name: 'dealerAndVehicleData',
  initialState,
  reducers: {
    setDealer: (state, action) => {
      return { ...state, dealer: action.payload };
    },
    setVehicle: (state, action) => {
      return { ...state, vehicle: action.payload };
    },
    setCarlineVehicle: (state, action) => {
      return { ...state, vehicleByCarline: action.payload };
    },
    setAudiCodeVehicle: (state, action) => {
      return { ...state, vehicleByAudiCode: action.payload };
    },
    removeVehicleInfo: (state) => {
      return {
        ...state,
        vehicleByAudiCode: undefined,
        vehicleByCarline: undefined,
        vehicle: undefined,
      };
    },
  },
});

export const selectDealerAndVehicleData = (state: RootState) => state.dealerAndVehicleData;

export const { setDealer, setVehicle, setCarlineVehicle, setAudiCodeVehicle, removeVehicleInfo } =
  dealerAndVehicleSlice.actions;

export default dealerAndVehicleSlice.reducer;
